import { render, staticRenderFns } from "./UserListSummary.vue?vue&type=template&id=37ecea7a&scoped=true&"
import script from "./UserListSummary.vue?vue&type=script&lang=ts&"
export * from "./UserListSummary.vue?vue&type=script&lang=ts&"
import style0 from "./UserListSummary.vue?vue&type=style&index=0&id=37ecea7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ecea7a",
  null
  
)

export default component.exports